module.exports = ["gsmsteve@gmail.com","garygoldberg@comcast.net","gargatrolian@gmail.com"]


//////////////////
// WEBPACK FOOTER
// ./src/store/module/admins.json
// module id = g6zf
// module chunks = 1